import { useEffect, useState } from "react";
import useReitList from "../../../../../api/hooks/hooks-reit-facility/use-facility-reit-list";
import styles from "./styles.module.scss";
import {
  getImgFromObjectFacility,
  toReadablePrice,
} from "../../../../../lib/utils";
import Loader from "../../../../ui/loader";
import FacilityCardModal from "../modals/facilityCardModal";
import clsx from "clsx";
import useOpenModal from "../../../../ui/modal/hooks/useOpenModal";

const IMG_NOT_FOUND_PLAN = "../img/notfoundPlan.jpg";

interface IReitFacilityTable {
  facilityTypeIds: number[];
  isLoadingType: boolean;
  heightTable: number;
}

const ReitFacilityTable = ({
  facilityTypeIds,
  isLoadingType,
  heightTable,
}: IReitFacilityTable) => {
  const { reitList, error, isMutating, trigger } = useReitList();
  const { offsetY, open, handleChangeModal } = useOpenModal();
  const [currentId, setCurrentId] = useState<number>();

  const handleClick = (id: number) => {
    handleChangeModal(true);
    setCurrentId(id);
  };

  useEffect(() => {
    trigger({ typeIds: facilityTypeIds });
  }, [facilityTypeIds]);

  if (isMutating || isLoadingType) {
    return (
      <div className={styles.facilityTable__loader}>
        <Loader />
      </div>
    );
  }

  return (
    <div className={styles.table}>
      <div
        className={styles.table__container}
        style={{ maxHeight: heightTable }}
      >
        <table cellSpacing="0" className={styles.table__table}>
          <tr className={styles.table__tr}>
            <th className={clsx(styles.table__th, styles.table__th_hide)}>№</th>
            <th className={styles.table__th}>Изображение</th>
            <th className={styles.table__th}>Квартира</th>
            <th className={styles.table__th}>Адрес</th>
            <th className={styles.table__th}>Цена</th>
          </tr>

          {reitList &&
            reitList?.map((facilityItem, index) => {
              const imgs = getImgFromObjectFacility(facilityItem);
              return (
                <tr
                  key={facilityItem.id}
                  className={styles.table__tr}
                  onClick={() => handleClick(facilityItem.id)}
                >
                  <td className={clsx(styles.table__td, styles.table__td_hide)}>
                    {index + 1}
                  </td>
                  <td className={styles.table__td}>
                    <img
                      className={styles.table__img}
                      src={imgs[0]?.src ?? IMG_NOT_FOUND_PLAN}
                      alt={imgs[0]?.alt ?? "img.jpg"}
                    />
                  </td>
                  <td className={styles.table__td}>{facilityItem.title}</td>
                  <td className={styles.table__td}>
                    {facilityItem.building?.address}
                  </td>
                  <td className={styles.table__td}>
                    <div className={styles.table__priceTd}>
                      {toReadablePrice(facilityItem.currentPrice)}
                    </div>
                  </td>
                </tr>
              );
            })}
        </table>
      </div>
      {currentId && (
        <FacilityCardModal
          onClose={(value) => handleChangeModal(value)}
          opened={open}
          id={currentId}
          offsetY={offsetY}
        />
      )}
    </div>
  );
};

export default ReitFacilityTable;
